export enum EButtonType {
	SUBMIT = 'submit',
	RESET = 'reset',
	BUTTON = 'button',
}
